import { TagEntity } from '@interpals/api-web';
import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

const selectTagsState = (state: ReduxState) => state.tags;

export const selectTagSearchResults = createSelector(selectTagsState, (state): TagEntity[] => state.tagResults);

export const selectHasMoreTagSearchResults = createSelector(selectTagsState, (state): boolean => state.hasMoreResults);

export const selectSearchTagsIsPending = createSelector(selectTagsState, (state): boolean => state.searchTagsIsPending);

export const selectUpdateUserTagsIsPending = createDraftSafeSelector(
    selectTagsState,
    (state): boolean => state.updateUserTagsIsPending,
);
